import React from 'react'
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import faq1 from "../../Images/faq1.jpg"
import faq2 from "../../Images/faq2.jpg"
import faq3 from "../../Images/faq3.png"

import "./Carousel.css"


function Carosel() {
    const images = [faq1, faq2, faq3].map((number) => ({
        src: number
    }));
    console.log("images array ", images);
    return (
        <>
            <Carousel canAutoPlay={false} hasSizeButton={false} hasIndexBoard={false} images={images} className="carousel" />
        </>
    )
}

export default Carosel
